/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { TradingSummaryView } from "./trading-summary-view";
import { useTradingSummary } from "./use-trading-summary";

const TradingSummary = () => {
  const logic = useTradingSummary();

  return <TradingSummaryView {...logic} />;
};

export default TradingSummary;
